import React from 'react';

import CalendarContainer from './CalendarContainer';
import EventFormModal from './EventFormModal';
import AppUrlButton from './AppUrlButton';

import '../../vendor/libs/react-datepicker/react-datepicker.scss';

const CalendarPage = () => (
  <div>
    <CalendarContainer />
    <EventFormModal />
    <AppUrlButton />
  </div>
);

export default CalendarPage;
